module.exports = __webpack_public_path__ + "static/media/exhibition-services-img11.938cc0ca.jpg";